import AutovalidationCard from "features/User/pages/ApprovalsManagement/components/CardApprovalsInfo/AutovalidationCard"
import CardHeader from "features/User/pages/ApprovalsManagement/components/CardApprovalsInfo/CardHeader"
import React from "react"
import { useTranslation } from "react-i18next"
import {
  DOC_TYPES_KEYS,
  DocumentDetailCardProps,
  FLOW_STATUS_KEYS,
} from "../../../constant"
import DetailSteps from "../DetailSteps"

const DocumentDetailCard: React.FC<DocumentDetailCardProps> = ({
  validacion,
  isVistaDetail,
}) => {
  const { t } = useTranslation()
  const isEtapaRejected = validacion?.etapas?.some(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (etapa: $TSMigrationFixMe) => etapa.estado === FLOW_STATUS_KEYS[3].value
  )
  return (
    validacion && (
      <div className='tw-bg-simple-10 tw-rounded-md tw-shadow-sm'>
        <header className='tw-flex tw-justify-between tw-py-4 tw-px-6 tw-border-b tw-border-solid tw-border-neutral-25'>
          <CardHeader
            data={{
              tipoDocumento: validacion?.tipoDocumento || 2,
              rango: {
                operador: validacion?.rango?.operador,
                valorInferior: validacion?.rango?.valorInferior,
              },
              todosLosRangos: validacion.todosLosRangos,
            }}
            type={DOC_TYPES_KEYS(t)[validacion?.tipoDocumento || 2].label}
          />
        </header>
        <div className='tw-px-5 tw-py-2.5 [&>div:last-child::before]: [&>div:last-child::before]:tw-border-r-0'>
          {validacion.autovalidacion ? (
            <AutovalidationCard
              backgroundColor='#30D59B'
              flexContainer={undefined}
            />
          ) : (
            <>
              {validacion.etapas?.map(
                (
                  etapa: // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  any
                ) => {
                  return (
                    <DetailSteps
                      etapa={etapa}
                      key={etapa.departamentoId}
                      isEtapaRejected={isEtapaRejected}
                      isVistaDetail={isVistaDetail}
                      etapas={validacion.etapas}
                      flexContainer={false}
                    />
                  )
                }
              )}
            </>
          )}
        </div>
      </div>
    )
  )
}

export default DocumentDetailCard
